import React, { ComponentType } from "react"
import { NodeProps } from "reactflow"
import { Grid, Typography } from "@material-ui/core"

import { BlockNodeData } from "@/protocols/chatBotFlow"

import useChatBotFlowConstructorStore from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowConstructorStore"
import useChatBotFlowBlockDetails from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowBlockDetails"

import BaseBlock from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BaseBlock"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionGroup from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionGroup"
import AfterActionConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/AfterActionConditionSection"
import TagChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/TagChip"
import ContrastChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/ContrastChip"
import WithoutAICreditsConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIConditionBlock/WithoutAICreditsConditionSection"

import TagManagementSectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIManageClientTagsBlock/TagManagementSectionEditor"
import NoTagsIdentifiedConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIManageClientTagsBlock/NoTagsIdentifiedConditionSection"

import { getCurrentTagsOptions } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockContent"

import { colors } from "@/styles/colors"

import useStyles from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIManageClientTagsBlock/styles"

const AIManageClientTagsBlock: ComponentType<NodeProps<BlockNodeData>> = (node) => {
	const chatBotFlowConstructorStore = useChatBotFlowConstructorStore()
	const chatBotFlowBlockDetails = useChatBotFlowBlockDetails({ chatBotFlowBlockId: node.data.chatBotFlowBlockId })

	const classes = useStyles()

	const currentTagsOptions = getCurrentTagsOptions(
		chatBotFlowConstructorStore.constructionResources,
		chatBotFlowBlockDetails.content
	)
	const selectedTags = currentTagsOptions.tagsToAdd

	return (
		<BaseBlock
			node={node}
		>
			<BlockBodySectionGroup>
				<BlockBodySection
					fullWidth
				>
					<TagManagementSectionEditor
						chatBotFlowBlockContent={chatBotFlowBlockDetails.content}
						onSave={content => chatBotFlowBlockDetails.changeContent(content)}
					>
						<Grid className={classes.tagsSummaryCard}>
							<Typography className={classes.tagsSummaryLabel}>
								Tags que o bloco pode atribuir:
							</Typography>

							<Grid className={classes.tagsSummaryChips}>
								{selectedTags.length > 0 ? (
									selectedTags.map(tag => (
										<TagChip
											key={tag.id}
											name={tag.name}
											color={tag.color}
											className={classes.tagChip}
										/>
									))
								) : (
									<ContrastChip
										title="Nenhuma tag selecionada"
										backgroundColor={colors.gray[100]}
									/>
								)}
							</Grid>
						</Grid>
					</TagManagementSectionEditor>
				</BlockBodySection>
			</BlockBodySectionGroup>

			<BlockBodySectionGroup>
				<AfterActionConditionSection
					nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
				/>
			</BlockBodySectionGroup>

			<WithoutAICreditsConditionSection
				nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
				text="Se os créditos de IA acabarem"
			/>

			<NoTagsIdentifiedConditionSection
				nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
				text="Se nenhuma tag for atribuída"
			/>
		</BaseBlock>
	)
}

export default AIManageClientTagsBlock
